import { mkLoginBtnTrackAttrs } from '@/analytics/props/threadBar';
import { useAuth0 } from '@/auth/Auth0Client';

import { alpha, Button } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import styled from 'styled-components';

export const LoginPromo = () => {
  const { login } = useAuth0();

  return (
    <Wrapper>
      <Title>Save your work</Title>
      <p>
        Logging in allows you to revisit questions and answers in the future.
      </p>
      <LoginButton
        {...mkLoginBtnTrackAttrs()}
        onClick={login}
        startIcon={<LoginIcon />}
      >
        Login
      </LoginButton>
    </Wrapper>
  );
};

const Wrapper = styled('div')(({ theme }) => ({
  backgroundColor: alpha(theme.color['teal-100'].hex, 0.2),
  borderRadius: '4px',
  color: theme.color['cream-100'].hex,
  fontSize: theme.typography.body2.fontSize,
  margin: theme.spacing(1.5),
  padding: theme.spacing(1.5),
  'text-wrap': 'auto',
}));

const Title = styled('p')`
  font-weight: 700;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

const LoginButton = styled(Button)`
  &.MuiButton-root {
    color: ${({ theme }) => theme.palette.secondary.main};
  }
`;
